import { EFiscalDocumentStatus } from "./EFiscalDocumentStatus"

const fiscalDocumentStatusTranslationKeys: Record<EFiscalDocumentStatus, string> = {
  [EFiscalDocumentStatus.Pending]: "status.pending",
  [EFiscalDocumentStatus.Processing]: "status.processing",
  [EFiscalDocumentStatus.Authorized]: "status.authorized",
  [EFiscalDocumentStatus.Rejected]: "status.rejected",
  [EFiscalDocumentStatus.Contingency]: "status.contingency",
  [EFiscalDocumentStatus.Canceled]: "status.canceled",
  [EFiscalDocumentStatus.CancellationPending]: "status.cancellationPending",
}

export const getFiscalDocumentStatusTranslationKey = (status: EFiscalDocumentStatus) =>
  fiscalDocumentStatusTranslationKeys[status]


export const isIssuedFiscalDocumentStatus = (status: EFiscalDocumentStatus) =>
  status === EFiscalDocumentStatus.Authorized ||
  status === EFiscalDocumentStatus.Contingency ||
  status === EFiscalDocumentStatus.Canceled ||
  status === EFiscalDocumentStatus.CancellationPending
